export const getApiUrl = (): string => {
  if (window.location.hostname === "localhost") {
    return "http://localhost:3001";
  }
  return "https://aimply-webapp-api-499b77f2f271.herokuapp.com";
};

export const getApiUrlWithVersion = (version: string = "1"): string => {
  return `${getApiUrl()}/api/v${version}`;
};

export const getPythonApiUrl = (): string => {
  if (window.location.hostname === "localhost") {
    return "http://localhost:8000";
  }
  return "https://potions-python-api-b8ddfd72da39.herokuapp.com";
};

export const getPythonApiUrlWithVersion = (version: string = "1"): string => {
  return `${getPythonApiUrl()}/api/v${version}`;
};

export const getWebsiteUrl = (): string => {
  if (window.location.hostname === "localhost") {
    return "http://localhost:3000";
  }

  const hostname = window.location.hostname;

  // If on a whitelabel domain, preserve it
  if (hostname.includes('unifiedmmg') ||
    hostname.includes('instantestimate') ||
    hostname.includes('authoritydigest') ||
    hostname.includes('askspectra') ||
    hostname.includes('spectratechconsultants')) {
    return `https://${hostname}`;
  }

  // Default to app.withpotions.com
  return "https://app.withpotions.com";
};


export const IS_PRODUCTION = process.env.NODE_ENV === 'production';

// env vars need to be prefixed with "REACT_APP_" to be included in the build process
export const STATSIG_API_KEY = process.env.REACT_APP_STATSIG_CLIENT_SDK_API_KEY!;
export const STRIPE_API_PUBLISHABLE_KEY = process.env.REACT_APP_STRIPE_API_PUBLISHABLE_KEY!;
